import React, { useEffect, useRef, useState } from 'react';
import M_PER_CUSTOM_01 from './M_PER_CUSTOM_01';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useFcmHandler from '../../../../Hooks/useFcmHandler';
import { M_PER_CUSTOM_01_Schema } from './M_PER_CUSTOM_01_Schema';
import {
  useSave1,
  useSave2,
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4 as useSearchApprovalCandidates,
} from './M_PER_CUSTOM_01_Query';
import { useSearch4 as useSearchRecentApprovalLine } from '../M_PER_CUSTOM/M_PER_CUSTOM_Query';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import { useSave } from '../../../../Hooks/useSave';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { normalizeApprovalLine } from '../utils/approvalLine';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
import { createInitial } from '../../../../util';

export default function M_PER_CUSTOM_01F() {
  const activeStep = useSelector((state) => state.common.activeStep);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { id } = useParams(); // 작업허가서 수정할 때 param으로 받아서 pmCd 받아옴
  const { baseInfo, codeInfo, depApproval } = useSelector(
    (state) => state.permit
  );
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();

  const [rowData2, setRowData2] = useState([]); // 반려 시 기본 정보
  const [rowData3, setRowData3] = useState([]); // 반려 시 체크리스트
  const [recentApproverRows, setRecentApproverRows] = useState(null);

  const sendFcm = useFcmHandler();
  const [errors, setErrors] = useState({});
  const activeStepRef = useRef(activeStep);

  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  useEffect(() => {
    // 스택형 뒤로가기로 변경: write 진입 직후 step을 먼저 맞춤
    dispatch(CommonActions.setActiveStep(1));
    dispatch(PermitActions.resetApprovalLine());
    SearchApprovalCandidates();

    if (id) {
      Search3({ pmCd: id });
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (recentApproverRows === null || depApproval.length === 0) return;

    dispatch(
      PermitActions.initializeApprovalLine(
        normalizeApprovalLine(recentApproverRows, depApproval)
      )
    );
  }, [recentApproverRows, depApproval, dispatch]);

  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      dispatch(
        PermitActions.setCodeInfo({
          workTypes: rows,
        })
      );
    },
  });
  const { run: Search2 } = useSearch2({
    onSuccess: (data) => {
      const details = data[0];

      dispatch(
        PermitActions.setCodeInfo({
          risks:
            details.riskCodes?.map((r) => ({
              ...r,
              itemCheck: baseInfo.savedRiskCodes?.includes(String(r.riskCode))
                ? 'Y'
                : '',
            })) || [],

          equips:
            details.equipCodes?.map((e) => ({
              ...e,
              itemCheck: baseInfo.savedEquipCodes?.includes(
                String(e.workEquipCode)
              )
                ? 'Y'
                : '',
            })) || [],

          preparations:
            details.preparationCodes?.map((p) => ({
              ...p,
              itemCheck: baseInfo.savedPrepCodes?.includes(
                String(p.preparationCode)
              )
                ? 'Y'
                : '',
            })) || [],
        })
      );
    },
  });

  useEffect(() => {
    if (bottomSheetState?.bottom === true) {
      return;
    }
  }, [bottomSheetState?.bottom]);

  // 스택형 뒤로가기로 변경: 첫 단계에서는 이탈 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: activeStep === 1 && !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClick' })),
  });

  // 스택형 뒤로가기로 변경: 다음 단계에서는 이전 단계로 복귀
  useBackStack({
    type: 'step',
    enabled: activeStep > 1 && activeStep < 6,
    onBack: () =>
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1)),
  });

  // 작업허가서 상세 조회 수정할 때 필요함
  const { run: Search3 } = useSearch3({
    onSuccess: (data) => {
      if (!data || data.length === 0) return;
      const resBaseInfo = data[0];

      const parseItemList = (listStr, type) => {
        if (!listStr) return [];
        return listStr.split('||').map((item) => {
          const [code, name, checked] = item.split('|');
          return {
            [type === 'risk'
              ? 'riskCode'
              : type === 'equip'
                ? 'workEquipCode'
                : 'preparationCode']: code,
            [type === 'risk'
              ? 'riskNm'
              : type === 'equip'
                ? 'workEquipNm'
                : 'preparationNm']: name,
            itemCheck: checked === 'Y' ? 'Y' : '',
          };
        });
      };

      const risks = parseItemList(resBaseInfo.riskItemsList, 'risk');
      const equips = parseItemList(resBaseInfo.equipmentItemsList, 'equip');
      const preparations = parseItemList(
        resBaseInfo.preparationItemsList,
        'prep'
      );

      dispatch(
        PermitActions.setCodeInfo({
          risks,
          equips,
          preparations,
        })
      );

      dispatch(
        PermitActions.setBaseInfo({
          ...resBaseInfo,
          permissionDate: resBaseInfo.permissionDate?.split(' ')[0] || '',
          workType: resBaseInfo.workTypeCode || '',
          savedRiskCodes: resBaseInfo.selectedRiskCodes?.split(',') || [],
          savedEquipCodes: resBaseInfo.selectedEquipmentCodes?.split(',') || [],
          savedPrepCodes:
            resBaseInfo.selectedPreparationCodes?.split(',') || [],
        })
      );

      setRowData2(resBaseInfo);
    },
  });
  const { run: SearchApprovalCandidates } = useSearchApprovalCandidates({
    onSuccess: (rows) => {
      const grouped = rows.reduce((acc, curr) => {
        const { depCd, depNmLast } = curr;

        if (!acc[depCd]) {
          acc[depCd] = {
            depCd: depCd,
            depNm: depNmLast,
            managers: [],
          };
        }

        acc[depCd].managers.push({
          id: curr.id,
          name: curr.name,
          position: curr.position,
          photo: curr.photo,
          tel: curr.tel,
        });

        return acc;
      }, {});

      const finalData = Object.values(grouped);
      dispatch(PermitActions.setDepApproval(finalData));
    },
  });
  useSearchRecentApprovalLine({
    onSuccess: (rows) => {
      setRecentApproverRows(rows ?? []);
    },
  });
  const { mutateAsync: save1Async } = useSave1();
  const { mutateAsync: save2Async } = useSave2();
  const { run: Save1 } = useSave({
    menuId: 'M_PER_CUSTOM_01',
    schema: M_PER_CUSTOM_01_Schema,
    saveData: (params) => ({
      ...params,
      baseInfo,
      codeInfo,
    }),
    requestSave: async (rows) => {
      const row = rows[0];
      const res1 = await save1Async(row);
      const newPmCd = res1?.pmCd || res1?.data?.[0]?.pmCd || row.baseInfo.pmCd;

      const selectedHeads = row.depHeads || [];
      if (selectedHeads.length > 0) {
        for (const head of selectedHeads) {
          if (head?.headId) {
            await save2Async({ ...row, pmCd: newPmCd, currentHead: head });
          }
        }
      }

      return res1;
    },
    onSuccess: async ({ saveDetailData, requestRows, userInfo }) => {
      const result = saveDetailData?.[0];
      const serverPmCd = result?.pmCd || result?.data?.[0]?.pmCd;

      if (!serverPmCd) return;

      const context = requestRows[0];
      const selectedHeads = context.depHeads || [];

      if (selectedHeads.length > 0) {
        for (const head of selectedHeads) {
          try {
            await sendFcm({
              targetUserId: head.headId,
              requestUserId: userInfo.userid,
              title: '작업허가서 요청',
              body: '새로운 작업 허가서 승인 요청이 있습니다.',
              status: '요청',
              codeGroup: 'AL_002_001',
              route: '/M_Permit',
              responseData: serverPmCd,
            });
          } catch (err) {
            console.error('FCM 전송 실패:', err);
          }
        }
      }

      dispatch(CommonActions.increaseStep());
      dispatch(BottomSheetActions.CloseBottomSheet());
      dispatch(
        showSnackbar({
          message: '작업허가서 요청이 완료되었습니다.',
          type: 'success',
        })
      );
      dispatch(PermitActions.resetPermitForm('CUSTOM'));
    },
  });

  const prevWorkType = useRef(null);

  useEffect(() => {
    if (id && rowData2?.workType && prevWorkType.current === null) {
      prevWorkType.current = rowData2.workType;
    }
  }, [id, rowData2]);

  useEffect(() => {
    if (!id) return;
    if (prevWorkType.current === null) return;

    const currentWorkType = String(baseInfo.workType || '');
    const prevWorkTypeValue = String(prevWorkType.current || '');

    if (currentWorkType !== prevWorkTypeValue) {
      dispatch(
        PermitActions.setCodeInfo({
          risks: [],
          equips: [],
          preparations: [],
        })
      );

      setRowData3([]);

      dispatch(
        PermitActions.setBaseInfo({
          savedRiskCodes: [],
          savedEquipCodes: [],
          savedPrepCodes: [],
        })
      );

      if (currentWorkType && codeInfo.workTypes) {
        const selectedWorkType = codeInfo.workTypes.find(
          (wt) => wt.workType === currentWorkType
        );
        if (selectedWorkType?.workItemId) {
          Search2({ workItemId: selectedWorkType.workItemId });
        }
      }
    }

    prevWorkType.current = baseInfo.workType;
  }, [id, baseInfo.workType, codeInfo.workTypes, dispatch]);

  const baseInfoFields = M_PER_CUSTOM_01_Schema.fields.baseInfo;

  const ValidateAll = () => {
    const nextErrors = Object.keys(baseInfoFields).reduce((acc, name) => {
      const meta = baseInfoFields[name];
      if (meta?.step !== 1) return acc;
      if (meta?.variants && !meta.variants.includes('CUSTOM')) return acc;
      if (meta?.required !== 'Y') return acc;
      if (String(baseInfo[name] ?? '').trim() !== '') return acc;
      acc[name] = `${meta.label}을(를) 입력하세요.`;
      return acc;
    }, {});

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleChange = (name, value) => {
    dispatch(PermitActions.setBaseInfo({ [name]: value ?? '' }));

    const meta = baseInfoFields[name];
    if (meta?.step !== 1 || meta?.required !== 'Y') return;
    setErrors((prev) => ({
      ...prev,
      [name]:
        String(value ?? '').trim() === ''
          ? `${meta.label}을(를) 입력하세요.`
          : '',
    }));
  };

  const computedCheckList = (() => {
    if (!codeInfo?.groupedCheckLists) return {};

    const workType = baseInfo.workType || '';
    if (!workType) return {};

    const wt = String(workType).trim().toUpperCase();
    const allKeys = Object.keys(codeInfo.groupedCheckLists);
    const matchedKey = allKeys.find((k) => k.trim().toUpperCase() === wt);

    return {
      [wt]: matchedKey ? codeInfo.groupedCheckLists[matchedKey] : [],
    };
  })();

  return (
    <div className="wrap">
      <M_PER_CUSTOM_01
        id={id}
        activeStep={activeStep}
        rowData2={rowData2}
        rowData3={rowData3}
        errors={errors}
        codeListForCheckList={computedCheckList}
        // 함수
        ValidateAll={ValidateAll}
        handleChange={handleChange}
        Search2={Search2}
        Save1={Save1}
      />
    </div>
  );
}
